import { render, staticRenderFns } from "./courses_single.vue?vue&type=template&id=6b9b3076&"
import script from "./courses_single.vue?vue&type=script&lang=js&"
export * from "./courses_single.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports